<template>
  <div class="container mt-30 mb-30">
    <div class="row">
      <div class="col loader" v-if="loader">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="col post" v-else>
        <div class="text" v-html="selectPost.newContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["selectPost", "loader"])
  },
  created() {
    let postId = this.$route.params.id;
    this.$store.dispatch("fetchPost", postId);
  }
};
</script>


<style lang="scss">
.text {
  width: 100%;
  img {
    width: 100% !important;
    height: 600px!important;
    object-fit: cover;
  }
}
@media (max-width: 767px) {
  .text {
    img {
      width: 100% !important;
      height: 300px!important;
      object-fit: cover;
    }
  }
}
</style>